var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgByRestApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.797 39.3467L24.8746 45.4242L30.9521 39.3467",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8748 24.4585V45.4247",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3089 35.6398C8.90338 34.0951 6.96611 31.8853 5.71724 29.2616C4.46836 26.638 3.95796 23.7055 4.24402 20.7976C4.53009 17.8896 5.60115 15.1227 7.3355 12.8113C9.06986 10.4999 11.398 8.73661 14.0553 7.72186C16.7126 6.70711 19.5925 6.48156 22.3679 7.07085C25.1433 7.66014 27.7028 9.04063 29.7555 11.0555C31.8083 13.0703 33.2721 15.6387 33.9804 18.4687H36.3662C38.877 18.4687 41.285 19.4976 43.0604 21.329C44.8359 23.1604 45.8333 25.6444 45.8333 28.2344C45.8333 30.8244 44.8359 33.3083 43.0604 35.1397C42.0682 36.1633 40.8783 36.9362 39.5833 37.4189",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByRestApi);
export default __webpack_public_path__ + "static/media/ByRestAPI.be1ad63f3d12b80a333c4537b127a278.svg";
export { ForwardRef as ReactComponent };